// extracted by mini-css-extract-plugin
export default {"pip_preview":"productImgPicker_pip_preview__F349H","overlay":"productImgPicker_overlay__DnuKZ","pick_img":"productImgPicker_pick_img__XD3+9"};